import { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { getTargetInfoByMMSI } from './getTargetInfoByMMSI';
import { QueryPointResult } from '../extractTargetInfo';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';
import { useRefetchOnSocketChange } from '../useRefetchOnSocketChange';

export const useGetTargetByMMSI = (
  mmsi: number,
  options?: Partial<
    UseQueryOptions<QueryPointResult, Error, QueryPointResult, unknown[]>
  >,
): UseQueryResult<QueryPointResult> => {
  const { olSession, sessionId } = useSession();

  const query = useQuery(
    {
      // Key on the stable `sessionId`, not the per-reconnect
      // `olSession.socketId`. A request on the grace window's CLOSED socket can
      // hang the query in `fetching`, so the transport change must still
      // refetch — `useRefetchOnSocketChange` does that without multiplying
      // entries — otherwise the follow-ship indicator freezes until the user
      // unfollows or reloads.
      queryKey: ['getTargetByMMSI', sessionId, mmsi],
      queryFn: () => getTargetInfoByMMSI(olSession, mmsi),
      ...options,
    },
    'target:getByMMSI',
  );

  useRefetchOnSocketChange(olSession?.socketId, query.isEnabled, query.refetch);

  return query;
};
